import { Brand } from 'src/types/brandTypes';

const WORKFLOW_TAG_FILTER_KEY = 'workflow_tags';

export const resolveBrandWorkflowTags = (
  selectedBrandIds: string[],
  brands: Brand[],
): string[] => {
  const selectedBrandId = selectedBrandIds[0];
  if (!selectedBrandId) {
    return [];
  }

  const selectedBrand = brands.find(
    brand => brand.brand_id === selectedBrandId,
  );

  if (!selectedBrand) {
    return [];
  }

  return [
    ...new Set(selectedBrand.tags.map(tag => tag.trim()).filter(Boolean)),
  ];
};

export const applyBrandWorkflowTags = (
  intentFilters: string[],
  selectedBrandIds: string[],
  brands: Brand[],
): string[] => {
  const unrelatedFilters = intentFilters.filter(filter => {
    const separatorIndex = filter.indexOf('.');
    const key =
      separatorIndex === -1 ? filter : filter.slice(0, separatorIndex);

    return key !== WORKFLOW_TAG_FILTER_KEY;
  });
  const workflowTags = resolveBrandWorkflowTags(selectedBrandIds, brands);

  return [
    ...unrelatedFilters,
    ...workflowTags.map(tag => `${WORKFLOW_TAG_FILTER_KEY}.${tag}`),
  ];
};
